'use client';

import { useState } from 'react';

import { Send } from 'lucide-react';
import { useTranslations } from 'next-intl';

import { EmojiPickerButton } from './EmojiPickerButton';

interface PinPopoverReplyInputProps {
  onAddReply: (message: string) => void;
}

export function PinPopoverReplyInput({
  onAddReply,
}: PinPopoverReplyInputProps) {
  const t = useTranslations();
  const [replyDraft, setReplyDraft] = useState('');

  function submitReply() {
    const message = replyDraft.trim();
    if (!message) return;
    onAddReply(message);
    setReplyDraft('');
  }

  return (
    <div className="flex items-center gap-2 border-t border-border px-3 py-2">
      <input
        type="text"
        value={replyDraft}
        onChange={(e) => setReplyDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submitReply();
        }}
        placeholder={t('get-feedback-pinReply-placeholder')}
        className="flex-1 min-w-0 rounded-md border border-input bg-background px-2 py-1 text-xs text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring"
      />
      <EmojiPickerButton
        onEmojiSelect={(emoji) => setReplyDraft((prev) => prev + emoji)}
      />
      <button
        onClick={submitReply}
        aria-label={t('get-feedback-pinReply-send')}
        className="flex-shrink-0 text-muted-foreground hover:text-foreground transition-colors disabled:opacity-40"
        disabled={!replyDraft.trim()}
      >
        <Send className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
